import angular from 'angular';
import { pick } from 'lodash';

module.exports = angular.module('admin.services.address-client', [
    'server.common-constants'
])
.factory('AddressClient', function(Addresses, $http, $q) {
  const ADDRESS_URI = Addresses.BASE_DWELLINGS_URL + '/api/v1/addresses/';
  const TRANSACTION_COUNT_URI = Addresses.BASE_DWELLINGS_URL + '/api/v1/agents/transaction_count';
  const INFO_SUFFIX = 'info';
  const INFO_PARAMS = ['address_token', 'street1', 'unit', 'city', 'state', 'postal_code'];

  const transformResponse = (httpPromise) => {
    return httpPromise.then((result) => result.data).catch((err) => {
      if (err.status === 404) {
        return {};
      }
      return $q.reject(err);
    });
  };

  class AddressClient {
    info(address) {
      let params = { params: pick(address, INFO_PARAMS) };
      return transformResponse($http.get(ADDRESS_URI + INFO_SUFFIX, params));
    }

    transactionCount(phone_number, email, startDate, endDate) {
      let params = { phone_number: phone_number, email: email, start: startDate, end: endDate };
      return transformResponse($http.get(TRANSACTION_COUNT_URI, { params: params }));
    }
  }

  return new AddressClient();
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/address-client.js
 **/